// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__33iUK","selects":"Documents_selects__2UHOF"};